import { FunctionComponent } from 'react';

import BannerSection from '@/components/BannerSection';
import InfoBannerSection from '@/components/InfoBannerSection';
import RealizationsListSection from '@/components/realizations/RealizationsListSection';
import Head from 'next/head';

const Realizations: FunctionComponent = () => {
  return (
    <div className="w-full bg-white overflow-hidden tracking-[normal] text-left text-[1rem] text-gray-500">
      <Head>
        <title>Realizacje</title>
        <meta name="description" content="Lista realizacji firmy Binnar" />
      </Head>
      <BannerSection
        imageUrl="/realizations/realizations-hero.webp"
        title="Nasze realizacje"
        description="Każda realizacja to efekt współpracy z klientami, którzy zaufali naszej wiedzy i doświadczeniu."
      />
      <RealizationsListSection />
      <InfoBannerSection />
    </div>
  );
};

export default Realizations;
